import React from "react";
import styled, { keyframes } from "styled-components";
import LandingPageBg from "../../assets/images/bg.jpg";
const LandingPage = () => {
  return (
    <Wrapper>
      <SubWrapper>
        <ContentWrapper>
          <h1>
            Book Rides <br /> Anywhere
          </h1>
          <p>On Time, Every Time - Your Trusted Taxi Partner</p>
          <ButtonWrapper>
            <a href="tel:+919895136268">Call Now</a>
          </ButtonWrapper>
        </ContentWrapper>
      </SubWrapper>
    </Wrapper>
  );
};

export default LandingPage;

const Wrapper = styled.div`
  font-family: "Inter";
`;
const SubWrapper = styled.div`
  height: 100vh;
  width: 100%;
  background-image: url(${LandingPageBg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const ContentWrapper = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 5%;

  h1 {
    font-size: 60px;
    color: #fff;
    margin: 0px !important;
  }
  p {
    font-family: "Lato";
    color: #ffc107;
    font-size: 18px;
    font-weight: 300;
    margin-top: 10px;
    margin-bottom: 0px !important;
  }
`;
const ButtonWrapper = styled.div`
  margin-top: 15px;
  a {
    display: inline-block;
    background: #ecb10d;
    color: #ffffff;
    border: 1px solid #fff;
    border-radius: 4px;
    font-size: 15px;
    padding: 14px 23px;
    font-weight: 700;
    transition: all 0.5s ease-in-out 0s;
    text-transform: capitalize;
    letter-spacing: 0.08em;
    font-family: "Inter";
    cursor: pointer;
    text-decoration: none !important;
  }
`;
